import classNames from 'classnames';
import React from 'react';

// This class inspired by:
// https://stackoverflow.com/questions/12121090/responsively-change-div-size-keeping-aspect-ratio
const AspectRatio = ({styleName, children}) => {
  return (
    <div className={classNames("AspectRatio", styleName)}>
      <div className={classNames("AspectRatio__sizeConstraint", `${styleName}--size`)} />

      <div className={classNames("AspectRatio__content", `${styleName}--content`)}>
        {children}
      </div>
    </div>
  );
};

export default AspectRatio;



// WEBPACK FOOTER //
// ./src/components/AspectRatio.js